import axios from "axios";
import { BASE_URL } from "../../../variables";

export const addDealerNameApi = async (recType, sh2Code) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/getDealerSR/`,
    method: "post",
    data: { recType: recType, sh2Code: sh2Code },
  };
  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    return {
      success: false,
      msg: "Somthing Went Wrong..!!",
    };
  }
};
